export const spriteUrl = "/assets/sprites/icons-np.W4KrQGCvgkpDozAw62wqCg.svg"

export type IconName =
  | "360"
  | "acute"
  | "add"
  | "arrow_backward_lg"
  | "arrow_backward"
  | "arrow_downward_alt"
  | "arrow_forward_lg"
  | "arrow_forward"
  | "arrow_upward"
  | "arrows_more_up"
  | "autorenew"
  | "badge_lg"
  | "badge_md"
  | "bag"
  | "bearings"
  | "belt"
  | "brand_facebook"
  | "brand_instagram"
  | "brand_tiktok"
  | "brand_whatsapp"
  | "brand_youtube"
  | "break"
  | "check_circle_filled"
  | "check_circle"
  | "check_small"
  | "check"
  | "close"
  | "content_copy"
  | "delete"
  | "eco"
  | "edit_note"
  | "feather"
  | "fold"
  | "gift"
  | "guide"
  | "height"
  | "info_outline"
  | "keyboard_arrow_down"
  | "live_help"
  | "logo_panorama"
  | "menu"
  | "money_bag"
  | "outgoing_mail"
  | "package"
  | "padding"
  | "percent"
  | "quote"
  | "reddot"
  | "restore"
  | "roof"
  | "search"
  | "security"
  | "sell"
  | "shopping_cart_add"
  | "shopping_cart_off"
  | "shopping_cart"
  | "star_filled_half"
  | "star_filled"
  | "star"
  | "sueddeutsche"
  | "thumb_up"
  | "verified"
  | "weight"
  | "whatsapp"
  | "wheel"
  | "zoom_in"
